import { api } from '../lib/api';
import { useAsync } from '../lib/useAsync';
import { Badge, Card, EmptyState, ErrorAlert, PageHeader, Pagination, Spinner } from '../components/ui';
import { useState } from 'react';

export function SourcesPage() {
  const { data, error, loading } = useAsync(() => api.sources(), []);
  const [page, setPage] = useState(1);

  return (
    <>
      <PageHeader title="Sources" subtitle="Źródła wiedzy marki: strony, sitemapy, RSS, gazety, notatki." />
      {loading && <Spinner />}
      {error && <ErrorAlert error={error} />}
      {data && data.length === 0 && <EmptyState icon="⇲" title="Brak źródeł" hint="Dodaj źródła dla Brand Brain." />}
      {data && data.length > 0 && (
        <Card flush>
          <table className="table">
            <thead>
              <tr>
                <th>Nazwa</th>
                <th>Typ</th>
                <th>URL</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {data.slice((page - 1) * 12, page * 12).map((s) => (
                <tr key={s.id}>
                  <td style={{ fontWeight: 550 }}>{s.name}</td>
                  <td>
                    <Badge tone="neutral">{s.type}</Badge>
                  </td>
                  <td className="muted">{s.url ?? '—'}</td>
                  <td>
                    <Badge tone={s.enabled ? 'success' : 'neutral'}>{s.enabled ? 'enabled' : 'off'}</Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Pagination page={page} pageSize={12} total={data.length} onChange={setPage} />
        </Card>
      )}
    </>
  );
}
